module.exports = __webpack_public_path__ + "img/8000.5d1cbc0d.gif";